import Vue from "vue";
import VueRouter from "vue-router";
import dashboards from "../views/dashboards/dashboards.vue";
import Login from "../views/Login.vue";
import PageNotFound from "../views/404.vue";

import admin from "./admin";
import cars_model from "./cars_model";
import cars_brand from "./cars_brand";
import store from "./store";
import services from "./services";
import services_bulk from "./services_bulk";
import products from "./products";
import products_category from "./products_category";
import brand from "./brand";
import services_transaction from "./services_transaction";
import customers from "./customers";
import divisi from "./divisi";
import employee from "./employee";
import supplier from "./supplier";
import blog from "./blog";
import profile from "./profile";
import day_off from "./day_off";
import troubleshoot from "./troubleshoot";
import notifications from "./notifications";
import kasbon from "./kasbon";
import target from "./target";
import payroll from "./payroll";
import pembelian_produk from "./pembelian_produk";
import stock_opname from "./stock_opname";
import product_orders from "./product_orders";

Vue.use(VueRouter);

var allRoutes = [
  {
    path: "/",
    name: "Login",
    component: Login,
    meta: { guestOnly: true }
  },
  {
    path: "/dashboards",
    name: "dashboards",
    component: dashboards,
    meta: { authOnly: true }
  },
  { path: "*", component: PageNotFound }
];
allRoutes = allRoutes.concat(
  cars_model,
  blog,
  supplier,
  employee,
  admin,
  customers,
  cars_brand,
  store,
  services,
  services_bulk,
  products,
  services_transaction,
  products_category,
  brand,
  divisi,
  profile,
  day_off,
  troubleshoot,
  notifications,
  kasbon,
  target,
  payroll,
  pembelian_produk,
  stock_opname,
  product_orders
);
const routes = allRoutes;

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

function isLoggedIn() {
  return localStorage.getItem("token");
}

//  run before route
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.guestOnly)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (isLoggedIn()) {
      router.push({ name: "dashboards" });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.authOnly)) {
    if (isLoggedIn()) {
      next();
    } else {
      router.push({ name: "Login" });
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
